import { render } from "./PickImage.vue?vue&type=template&id=5731d793&scoped=true"
import script from "./PickImage.vue?vue&type=script&lang=ts"
export * from "./PickImage.vue?vue&type=script&lang=ts"

import "./PickImage.vue?vue&type=style&index=0&id=5731d793&lang=less&scoped=true"
import "./PickImage.vue?vue&type=style&index=1&id=5731d793&lang=less"
script.render = render
script.__scopeId = "data-v-5731d793"

export default script